/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { SummaryType } from "@fluidframework/driver-definitions";
/**
 * Validates the current layout of an .app + .protocol summary tree
 * this is used internally for create new, and single commit summary
 * @internal
 */
export function isCombinedAppAndProtocolSummary(summary, ...optionalRootTrees) {
    if (summary?.tree === undefined ||
        summary.tree?.[".app"]?.type !== SummaryType.Tree ||
        summary.tree?.[".protocol"]?.type !== SummaryType.Tree) {
        return false;
    }
    const treeKeys = Object.keys(summary.tree).filter((t) => !optionalRootTrees.includes(t));
    if (treeKeys.length !== 2) {
        return false;
    }
    return true;
}
/**
 * Extract the attributes from the protocol summary.
 * @param protocolSummary - protocol summary from which the values are to be extracted.
 * @internal
 */
export function getDocAttributesFromProtocolSummary(protocolSummary) {
    const attributesBlob = protocolSummary.tree.attributes;
    return JSON.parse(attributesBlob.content);
}
/**
 * Extract quorum values from the protocol summary.
 * @param protocolSummary - protocol summary from which the values are to be extracted.
 * @internal
 */
export function getQuorumValuesFromProtocolSummary(protocolSummary) {
    const quorumValuesBlob = protocolSummary.tree.quorumValues;
    const quorumValues = JSON.parse(quorumValuesBlob.content);
    return quorumValues;
}
//# sourceMappingURL=summaryForCreateNew.js.map